import React, { FunctionComponent, useState } from 'react';

import { getApiData } from 'scenes/common/helpers/apiData';
import { SingleYesNoStep } from 'scenes/common/components/Steps';
import { getHasModifications } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';

import HelpTextModal from './HelpTextModal';

const STATE_KEY = 'hasModifications';
const QUESTION =
  'Does the car have any non-standard accessories or modifications?';

const ModificationsStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [showModal, setShowModal] = useState(false);
  const helpLink = {
    id: 'what-does-this-mean-link',
    text: 'What does this mean?',
    ariaLabel: 'What does this mean? Opens dialog',
    onClick: () => setShowModal(true),
  };
  const { vehicleModifications } = getApiData(
    funnelState.apiResponses.quoteDetails
  );
  return (
    <>
      <SingleYesNoStep
        question={QUESTION}
        stateKey={STATE_KEY}
        defaultStateValue={getHasModifications(funnelState)}
        onNext={onNext}
        helpLink={helpLink}
      />
      <HelpTextModal
        isOpen={showModal}
        vehicleModifications={vehicleModifications}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default ModificationsStep;
